import { AxiosError } from 'axios'
import { ENDPOINTS } from 'constants/endpoints'
import apiInstance from 'services/api/instance'

import { handleErrorMessage } from '../errors'

export const getAll = async (): Promise<ActivityTaskApiResponse[]> => {
  try {
    const getAllResponse = await apiInstance.get<ActivityTaskApiResponse[]>(
      ENDPOINTS.ACTIVITY_TASK.GET_ALL,
    )

    return getAllResponse.data
  } catch (getAllError) {
    const axiosError = getAllError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const get = async (id: string): Promise<ActivityTaskApiResponse> => {
  try {
    const getResponse = await apiInstance.get<ActivityTaskApiResponse>(
      ENDPOINTS.ACTIVITY_TASK.GET(id),
    )

    return getResponse.data
  } catch (getError) {
    const axiosError = getError as AxiosError
    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const create = async (
  activityTask: ActivityTaskItemsForm,
): Promise<ActivityTaskApiResponse> => {
  try {
    const creationResponse = await apiInstance.post<ActivityTaskApiResponse>(
      ENDPOINTS.ACTIVITY_TASK.CREATE,
      activityTask,
    )

    return creationResponse.data
  } catch (creationError) {
    const axiosError = creationError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const update = async ({
  id,
  activityTask,
}: {
  activityTask: ActivityTasksApiRequest
  id: string
}): Promise<ActivityTaskApiResponse> => {
  try {
    const updateResponse = await apiInstance.put<ActivityTaskApiResponse>(
      ENDPOINTS.ACTIVITY_TASK.UPDATE(id),
      activityTask,
    )

    return updateResponse.data
  } catch (updateError) {
    const axiosError = updateError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}

export const remove = async (id: string) => {
  try {
    const deleteResponse = await apiInstance.delete(
      ENDPOINTS.ACTIVITY_TASK.DELETE(id),
    )

    return deleteResponse.data
  } catch (deleteError) {
    const axiosError = deleteError as AxiosError

    return Promise.reject(handleErrorMessage({ axiosError }))
  }
}
